function l_setInnerHTML(element, html) {
	element.innerHTML = html
	element.querySelectorAll('script').forEach((oldScript) => {
		const newScript = document.createElement('script')
		const attributes = [...oldScript.attributes]

		attributes.forEach((attr) => {
			newScript.setAttribute(attr.name, attr.value)
		})

		newScript.appendChild(document.createTextNode(oldScript.innerHTML))
		oldScript.parentNode.replaceChild(newScript, oldScript)
	})
}

function l_swapHtmlNode(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
	if (Array.isArray(preProcessCallbacks)) {
		preProcessCallbacks.forEach((cb) => cb?.(newContent))
	}

	const wrapper = document.createElement('div')
	l_setInnerHTML(wrapper, newContent.outerHTML)
	const newNode = wrapper.firstElementChild

	const timestampKey = Date.now()
	oldNode.querySelectorAll('[id], [form]').forEach((el) => {
		if (el.id) el.id = `${el.id}-${timestampKey}`
		if (el.form) {
			const formId = el.getAttribute('form')
			if (formId) el.setAttribute('form', `${formId}-${timestampKey}`)
		}
	})

	oldNode.parentNode.insertBefore(newNode, oldNode)
	oldNode.style.display = 'none'

	if (Array.isArray(postProcessCallbacks)) {
		postProcessCallbacks.forEach((cb) => cb?.(newNode))
	}

	setTimeout(() => {
		if (oldNode?.parentNode) oldNode.remove()
	}, 500)
}

function l_addClassesToRteTables() {
	document.querySelectorAll('.l-rte table, .shopify-policy__body .rte table').forEach((table) => {
		const wrapper = document.createElement('div')
		wrapper.classList.add('l-rte-table', 'l-overflow-x-auto', 'l-scrollbar--hidden')
		table.parentNode.insertBefore(wrapper, table)
		wrapper.appendChild(table)
	})
}

function l_smoothScrollOnAnchorTags() {
	document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
		const id = anchor.getAttribute('href').split('#')?.[1]
		if (!id) return

		anchor.addEventListener('click', (e) => {
			e.preventDefault()

			const block = anchor.getAttribute('data-scroll-block') || 'start'
			const inline = anchor.getAttribute('data-scroll-inline') || 'center'

			const target = document.querySelector(anchor.getAttribute('href'))
			target?.scrollIntoView?.({ behavior: 'smooth', block, inline })
		})
	})
}

function l_scrollToAnchoredSection(options = {}) {
	if (history.scrollRestoration) {
		history.scrollRestoration = 'manual'
	}

	const { offset = 0, behavior = 'auto', delay = 0 } = options

	const hash = window.location.hash
	if (!hash) return

	function l_scrollToTarget() {
		const targetId = hash.substring(1)
		const target = document.getElementById(targetId)

		if (!target) return

		const scrollOptions = {
			behavior,
			block: target.offsetHeight < window.innerHeight ? 'center' : 'start',
			inline: 'center',
		}

		target.scrollIntoView?.(scrollOptions)
	}

	if (delay > 0) {
		setTimeout(l_scrollToTarget, delay)
	} else {
		l_scrollToTarget()
	}
}

function l_preloadImage(container) {
	const imageEls = container.querySelectorAll('img')

	imageEls.forEach((imageEl) => {
		if (imageEl.complete) return

		const image = new Image()
		image.src = imageEl.src
	})
}

function l_getSectionDOM(html, selector = '.shopify-section') {
	return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)
}

function l_extractSectionId(element) {
	element = element.classList.contains('shopify-section') ? element : element.closest('.shopify-section')

	return element.id.replace('shopify-section-', '')
}

const l_getElement = (targetSelector, container) => {
	if (targetSelector instanceof Element) return targetSelector
	if (typeof targetSelector === 'string') {
		return targetSelector.startsWith('#')
			? container.getElementById(targetSelector.slice(1))
			: container.querySelector(targetSelector)
	}

	return null
}

function l_watchDOMChanges({ target, container = document, callback, once = false }) {
	const watchedEl = l_getElement(target, container)
	if (!watchedEl) return null

	const observer = new MutationObserver((mutationsList, obs) => {
		for (const mutation of mutationsList) {
			if (mutation.type === 'childList' && mutation.addedNodes.length) {
				callback(mutation.addedNodes, watchedEl)
				if (once) {
					obs.disconnect()
					break
				}
			}
		}
	})

	observer.observe(watchedEl, {
		attributes: true,
		childList: true,
		subtree: true,
	})

	return observer
}

function l_isElementInViewport(el) {
	const rect = el.getBoundingClientRect()
	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
		rect.right <= (window.innerWidth || document.documentElement.clientWidth)
	)
}

function l_initHoverPrefetchLinks(elements) {
	if (!elements || !elements.length) return

	const prefetched = new Set()
	let hoverTimer = null

	elements.forEach((link) => {
		if (!(link instanceof HTMLAnchorElement)) return

		link.addEventListener('mouseenter', () => {
			hoverTimer = setTimeout(() => {
				const href = link.href

				console.log(link)
				console.log(href)

				if (
					!href ||
					link.target === '_blank' ||
					href.startsWith('mailto:') ||
					href.startsWith('tel:') ||
					href.startsWith('#') ||
					prefetched.has(href) ||
					new URL(href).origin !== location.origin
				)
					return

				prefetched.add(href)

				const prefetch = document.createElement('link')
				prefetch.rel = 'prefetch'
				prefetch.href = href
				document.head.appendChild(prefetch)
			}, 120)
		})

		link.addEventListener('mouseleave', () => {
			clearTimeout(hoverTimer)
		})
	})
}

function isVisible(element) {
	if (!element) return false

	if (element.closest('[aria-hidden="true"], [hidden]')) return false

	const detailsParent = element.closest('details')
	if (detailsParent && !detailsParent.open && !detailsParent.contains(element.closest('summary'))) {
		return false
	}

	if (element.offsetParent === null && getComputedStyle(element).position !== 'fixed') {
		return false
	}

	const style = getComputedStyle(element)
	if (style.visibility === 'hidden' || style.visibility === 'collapse') return false

	if (element.getClientRects().length === 0) return false

	return true
}

function l_getFocusableElements(container) {
	const focusableSelectors = `summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe`

	return Array.from(container.querySelectorAll(focusableSelectors)).filter((el) => isVisible(el))
}

function l_disableFocusableElements(container) {
	l_getFocusableElements(container).forEach((el) => {
		el.setAttribute('tabindex', '-1')
		el.setAttribute('aria-disabled', 'true')
	})
}

function l_enableFocusableElements(container) {
	l_getFocusableElements(container).forEach((el) => {
		el.removeAttribute('tabindex')
		el.removeAttribute('aria-disabled')
	})
}

const l_trapFocusHandlers = {}

function l_trapFocus(container, defaultElementToFocus, enableFocusRange = true) {
	l_removeTrapFocus()

	l_trapFocusHandlers.keydown = (event) => {
		const key = event.code?.toUpperCase()
		const isTab = key === 'TAB'
		const isArrowDown = key === 'ARROWDOWN'
		const isArrowUp = key === 'ARROWUP'

		const elements = l_getFocusableElements(container)
		const [first, last] = [elements[0], elements[elements.length - 1]]
		const currentIndex = elements.indexOf(event.target)

		if (!elements.length) return

		if (isTab) {
			if ((event.target === last || last?.contains?.(event.target)) && !event.shiftKey) {
				event.preventDefault()
				first?.focus()
			} else if ((event.target === container || first?.contains?.(event.target)) && event.shiftKey) {
				event.preventDefault()
				last?.focus()
			}
			return
		}

		if (isArrowDown) {
			event.preventDefault()
			if (currentIndex === -1 || currentIndex === elements.length - 1) {
				first?.focus()
			} else {
				elements[currentIndex + 1]?.focus()
			}
			return
		}

		if (isArrowUp) {
			event.preventDefault()
			if (currentIndex === -1 || currentIndex === 0) {
				last?.focus()
			} else {
				elements[currentIndex - 1]?.focus()
			}
			return
		}
	}

	l_trapFocusHandlers.focusin = (event) => {
		if (container.contains(event.target)) {
			document.addEventListener('keydown', l_trapFocusHandlers.keydown)
		}
	}

	l_trapFocusHandlers.focusout = () => {
		document.removeEventListener('keydown', l_trapFocusHandlers.keydown)
	}

	document.addEventListener('focusin', l_trapFocusHandlers.focusin)
	document.addEventListener('focusout', l_trapFocusHandlers.focusout)

	const elements = l_getFocusableElements(container)
	const first = elements[0]
	const elementToFocus = defaultElementToFocus || first
	if (elementToFocus) {
		elementToFocus.focus()
		if (
			elementToFocus.tagName === 'INPUT' &&
			['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
			elementToFocus.value &&
			enableFocusRange
		) {
			elementToFocus.setSelectionRange(0, elementToFocus.value.length)
		}
	}
}

function l_removeTrapFocus(elementToFocus = null) {
	document.removeEventListener('focusin', l_trapFocusHandlers.focusin)
	document.removeEventListener('focusout', l_trapFocusHandlers.focusout)
	document.removeEventListener('keydown', l_trapFocusHandlers.keydown)
	if (elementToFocus) elementToFocus.focus()
}

function l_lockBodyScroll(elementName) {
	const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth

	document.documentElement.style.setProperty('--l-body-locked-width', `${scrollBarWidth}px`)

	document.body.classList.add('js-block-page')

	if (elementName) {
		document.body.classList.add(`js-block-page-${elementName}`)
	}
}

function l_unLockBodyScroll(elementName) {
	document.documentElement.style.removeProperty('--l-body-locked-width')

	if (elementName) {
		document.body.classList.remove(`js-block-page-${elementName}`)

		const isExistAnotherBlockedClass = Array.from(document.body.classList).some((cls) =>
			cls.startsWith('js-block-page-')
		)

		!isExistAnotherBlockedClass && document.body.classList.remove('js-block-page')
	} else {
		document.body.classList.remove('js-block-page')
	}
}

function l_setupGlobalVariables() {
	const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth

	document.documentElement.style.setProperty('--l-body-locked-width', `${scrollBarWidth}px`)
}

function l_setupVariablesBeforeOpenModal() {
	const announcementBarSection = document.getElementById('announcementBar')
	const headerSection = document.getElementById('header')

	document.documentElement.style.setProperty('--l-viewport-height', `${visualViewport?.height ?? window.innerHeight}px`)
	document.documentElement.style.setProperty('--l-header-height', `${headerSection?.offsetHeight || 0}px`)
	document.documentElement.style.setProperty(
		'--l-announcement-bar-height',
		`${announcementBarSection?.offsetHeight || 0}px`
	)

	return {
		headerHeight: headerSection?.offsetHeight || 0,
		announcementBarHeight: announcementBarSection?.offsetHeight || 0,
		headerTotalHeight: (headerSection?.offsetHeight || 0) + (announcementBarSection?.offsetHeight || 0),
		viewportHeight: visualViewport?.height ?? window.innerHeight,
	}
}

function l_setStaticHeaderGroupHeights() {
	const announcementBarSection = document.getElementById('announcementBar')
	const headerSection = document.getElementById('header')

	document.documentElement.style.setProperty('--l-header-height-static', `${headerSection?.offsetHeight || 0}px`)
	document.documentElement.style.setProperty(
		'--l-announcement-bar-height-static',
		`${announcementBarSection?.offsetHeight || 0}px`
	)
}

function l_initFakeMobileScrollbar() {
	const bar = document.getElementById('l-fake-scrollbar')
	if (!bar) return

	let hideTimeout = null

	const doc = document.documentElement
	const scrollTop = window.scrollY
	const docHeight = doc.scrollHeight
	const winHeight = window.innerHeight

	if (docHeight <= winHeight) {
		bar.style.opacity = 0
		return
	}

	const barHeight = Math.max(winHeight * (winHeight / docHeight), 40)
	const maxScroll = docHeight - winHeight
	const ratio = maxScroll ? scrollTop / maxScroll : 0

	bar.style.height = `${barHeight}px`
	bar.style.transform = `translateY(${ratio * (winHeight - barHeight)}px)`
	bar.style.opacity = 1

	clearTimeout(hideTimeout)
	hideTimeout = setTimeout(() => {
		bar.style.opacity = 0
	}, 1000)
}

function l_pauseAllMedia(container = document) {
	container.querySelectorAll('l-external-media').forEach((video) => {
		video?.pauseVideo?.()
	})
	container.querySelectorAll('.js-youtube').forEach((youtubeVideo) => {
		youtubeVideo.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
	})
	container.querySelectorAll('.js-vimeo').forEach((vimeoVideo) => {
		vimeoVideo.contentWindow.postMessage('{"method":"pause"}', '*')
	})
	container.querySelectorAll('video').forEach((video) => video.pause())
	container.querySelectorAll('product-model, l-product-model').forEach((model) => {
		if (model.modelViewerUI) model.modelViewerUI.pause()
	})
	container.querySelectorAll('video').forEach((video) => {
		video.pause()
	})
}

function l_playMedia(container = document) {
	container.querySelectorAll('l-external-media').forEach((video) => {
		video?.playVideo?.()
	})
	container.querySelectorAll('.js-youtube').forEach((youtubeVideo) => {
		youtubeVideo.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*')
	})
	container.querySelectorAll('.js-vimeo').forEach((vimeoVideo) => {
		vimeoVideo.contentWindow.postMessage('{"method":"play"}', '*')
	})
	container.querySelectorAll('product-model, l-product-model').forEach((model) => {
		if (model.modelViewerUI) model.modelViewerUI.play()
	})
	container.querySelectorAll('video').forEach((video) => {
		video.play()
	})
}

function l_removeMediaPlaceholderOnLoad() {
	const imageEls = document.querySelectorAll('.l-media-ratio img')
	if (!imageEls.length) return

	imageEls.forEach((imageEl) => {
		const l_removeClass = () => {
			imageEl.classList.remove('l-media-placeholder')
			imageEl.parentElement.classList.remove('l-media-placeholder')
		}

		if (imageEl.complete && imageEl.naturalWidth !== 0) {
			l_removeClass()
		} else {
			imageEl.addEventListener('load', l_removeClass, { once: true })
			imageEl.addEventListener('error', l_removeClass, { once: true })
		}
	})
}

function l_debounce(fn, wait) {
	let t

	return (...args) => {
		clearTimeout(t)
		t = setTimeout(() => fn.apply(this, args), wait)
	}
}

function l_throttle(fn, delay) {
	let lastCall = 0
	let timeout = null

	return function (...args) {
		const now = Date.now()
		const remaining = delay - (now - lastCall)

		if (remaining <= 0) {
			if (timeout) {
				clearTimeout(timeout)
				timeout = null
			}
			lastCall = now
			fn(...args)
		} else if (!timeout) {
			timeout = setTimeout(() => {
				lastCall = Date.now()
				timeout = null
				fn(...args)
			}, remaining)
		}
	}
}

function l_stepChain(steps, onDone) {
	const timeouts = []
	let totalDelay = 0
	let isCancelled = false

	steps.forEach(({ action, delay }, index) => {
		totalDelay += delay
		const timeoutId = setTimeout(() => {
			if (isCancelled) return
			action()
			if (index === steps.length - 1 && onDone) onDone()
		}, totalDelay)
		timeouts.push(timeoutId)
	})

	return {
		cancel: () => {
			isCancelled = true
			timeouts.forEach(clearTimeout)
		},
	}
}

function l_addEventDelegate({
	context = document.documentElement,
	event = 'click',
	selector,
	handler,
	capture = false,
}) {
	if (!context) return

	const listener = function (e) {
		for (let target = e.target; target && target !== this; target = target.parentNode) {
			if (target.matches(selector)) {
				handler.call(target, e, target)
				break
			}
		}
	}

	context.addEventListener(event, listener, capture)

	return () => {
		context.removeEventListener(event, listener, capture)
	}
}

function l_fetchConfig(type = 'json') {
	return {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
	}
}

function l_detectInputType() {
	const isMouse = matchMedia('(pointer:fine)').matches

	if (isMouse) {
		document.documentElement.classList.add('l-using-mouse')
	}

	const inputEvents = ['mousemove', 'mousedown', 'touchstart']

	inputEvents.forEach((eventName) => {
		document.addEventListener(
			eventName,
			l_debounce(() => {
				window.isUsingMouse = true
				document.documentElement.classList.add('l-using-mouse')
				document.documentElement.classList.remove('l-using-keyboard')
			}, 30)
		)
	})

	document.addEventListener('keydown', (e) => {
		if (e.key === 'Tab') {
			window.isUsingMouse = false
			document.documentElement.classList.add('l-using-keyboard')
			document.documentElement.classList.remove('l-using-mouse')
		}
	})
}

function l_normalizeString(str) {
	return str
		.normalize('NFD')
		.replace(/\p{Diacritic}/gu, '')
		.toLowerCase()
}

function l_handleize(str) {
	return str
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.toLowerCase()
		.replace(/[^a-z0-9]+/g, '-')
		.replace(/^-+|-+$/g, '')
		.replace(/--+/g, '-')
}

function l_formatMoney(cents, format = '') {
	let value = ''
	const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
	const formatString = format || window.LTATheme.money.format || '${{amount}}'

	if (typeof cents == 'string') {
		cents = cents.replace('.', '')
	}

	function defaultOption(opt, def) {
		return typeof opt == 'undefined' ? def : opt
	}

	function formatWithDelimiters(number, precision, thousands, decimal) {
		precision = defaultOption(precision, 2)
		thousands = defaultOption(thousands, ',')
		decimal = defaultOption(decimal, '.')

		if (isNaN(number) || number == null) {
			return 0
		}

		number = (number / 100.0).toFixed(precision)

		var parts = number.split('.'),
			dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
			cents = parts[1] ? decimal + parts[1] : ''

		return dollars + cents
	}

	switch (formatString.match(placeholderRegex)[1]) {
		case 'amount':
			value = formatWithDelimiters(cents, 2)
			break
		case 'amount_no_decimals':
			value = formatWithDelimiters(cents, 0, ' ', '.')
			break
		case 'amount_with_comma_separator':
			value = formatWithDelimiters(cents, 2, '.', ',')
			break
		case 'amount_no_decimals_with_comma_separator':
			value = formatWithDelimiters(cents, 0, '.', '.')
			break
	}

	return formatString.replace(placeholderRegex, value)
}

const l_openKlaviyoForms = (formId = 'UMEyPP') => {
	window._klOnsite = window._klOnsite || []
	window._klOnsite.push(['openForm', formId])
}

const l_setupKlaviyoFormTriggers = () => {
	document.querySelectorAll('a[href^="#klaviyo-form-"]').forEach((anchor) => {
		anchor.addEventListener('click', (event) => {
			const href = anchor.getAttribute('href')
			const formId = href && href.replace('#klaviyo-form-', '')
			if (!formId) return

			l_openKlaviyoForms(formId)
		})
	})
}

class LTACartServices {
	constructor(cartDrawer = null) {
		this.cartDrawer = cartDrawer
	}

	getBaseConfig() {
		return {
			method: 'POST',
			headers: {
				'X-Requested-With': 'XMLHttpRequest',
			},
		}
	}

	createConfigFromForm(formEl) {
		const config = this.getBaseConfig()
		const formData = new FormData(formEl)

		config.body = formData

		return config
	}

	createConfigFromItems(items = []) {
		const config = this.getBaseConfig()
		const formData = new FormData()

		items.forEach((item, index) => {
			const prefix = `items[${index}]`

			formData.append(`${prefix}[id]`, item.id)
			formData.append(`${prefix}[quantity]`, item.quantity)

			Object.entries(item).forEach(([key, value]) => {
				if (['id', 'quantity'].includes(key)) return
				if (key === 'properties' && value && typeof value === 'object') {
					Object.entries(value).forEach(([pKey, pVal]) => {
						if (pVal !== undefined && pVal !== null && pVal !== '') {
							formData.append(`${prefix}[properties][${pKey}]`, pVal)
						}
					})
				} else if (typeof value === 'object' && value !== null) {
					formData.append(`${prefix}[${key}]`, JSON.stringify(value))
				} else if (value !== undefined) {
					formData.append(`${prefix}[${key}]`, value)
				}
			})
		})

		config.body = formData
		return config
	}

	async addToCart(config, id = 'default') {
		const variantId = config?.body?.get?.('id') || config?.body?.get?.('items[0][id]') || null

		return fetch(`${window.LTATheme.routes.cart_add_url}.js`, config)
			.then((res) => res.json())
			.then((data) => {
				if (data?.status) {
					document.dispatchEvent(
						new CustomEvent('l:cart:error', {
							detail: {
								id,
								variantId,
								status: data.status,
								description: data.description,
								response: data,
							},
						})
					)

					return data
				}

				document.dispatchEvent(new CustomEvent('l:product:added', { bubbles: true, detail: { id, response: data } }))

				return data
			})
	}

	async changeCartLineItem(formData) {
		return fetch(`${window.LTATheme.routes.cart_change_url}.js`, { ...l_fetchConfig(), body: JSON.stringify(formData) })
			.then((res) => res.json())
			.then((data) => {
				return data
			})
	}
}

const ltaCartService = new LTACartServices()

class LTACollapsibleTab extends HTMLElement {
	constructor() {
		super()
	}

	connectedCallback() {
		this.triggerEl = this.querySelector('[data-trigger]') || document.querySelector(this.dataset.triggerSelector)
		this.contentEl = this.querySelector('[data-content]')

		this.expandedClass = 'is-expanded'
		this.collapsedClass = 'is-collapsed'
		this.openingClass = 'is-opening'
		this.closingClass = 'is-closing'
		this.collapsedHeight = '0px'
		this.oneAtATime = true
		this.isScrollIntoView = this.dataset.scrollIntoView === 'true'
		this.trapFocus = !this.hasAttribute('data-no-focus-trap') && this.dataset.trapFocus !== 'false'

		this.transitionendEvent = this.transitionendEventName()

		this.dataset.oneOpen === 'false' && (this.oneAtATime = false)

		if (this.getAttribute('open') === 'true') {
			this.selected = true
			this.contentEl.removeAttribute('hidden')
			this.contentEl.classList.remove('l-hidden')
			this.classList.add(this.expandedClass)
			this.setExpandedAria(false)
		} else {
			this.contentEl.style.height = this.collapsedHeight
			this.classList.add(this.collapsedClass)
			this.setCollapsedAria(null, false)
		}

		/* Stable ref: reconnects (e.g. l-drawer moved to <body>) must not stack listeners and double-toggle. */
		this._onTriggerClick ??= (e) => this.toggle(e)
		this.triggerEl?.addEventListener('click', this._onTriggerClick)
	}

	toggle(e) {
		e.preventDefault()

		this.selected ? this.close() : this.open()

		if (this.selected && this.oneAtATime) {
			const tabsContainer = this.closest('[data-collapsible-wrapper]')
			const collapsibleTabs = tabsContainer?.querySelectorAll('l-collapsible-tab')

			collapsibleTabs?.length &&
				collapsibleTabs.forEach((tab) => {
					tab !== this && tab.selected && tabsContainer !== tab && tab.close()
				})
		}
	}

	open() {
		this.selected = true
		this.expand()

		this.setExpandedAria()
		this.updateNestedCarousels()
	}

	close() {
		this.selected = false
		this.collapse()

		this.setCollapsedAria()
	}

	expand() {
		const onTransitionEnd = ((event) => {
			if (event.target !== this.contentEl || event.propertyName !== 'height') return

			this.contentEl.removeEventListener(this.transitionendEvent, onTransitionEnd)

			this.isOpen &&
				requestAnimationFrame(() => {
					this.classList.remove(this.openingClass)

					this.contentEl.style.transition = '0'
					this.contentEl.style.height = 'auto'

					requestAnimationFrame(() => {
						this.contentEl.style.height = null
						this.contentEl.style.transition = null
					})
				})
		}).bind(this)

		this.contentEl.addEventListener(this.transitionendEvent, onTransitionEnd)
		this.isOpen = true

		this.contentEl.removeAttribute('hidden')
		this.contentEl.classList.remove('l-hidden')

		this.classList.add(this.expandedClass, this.openingClass)
		this.classList.remove(this.collapsedClass, this.closingClass)

		this.contentEl.style.height = this.contentEl.scrollHeight + 'px'
	}

	collapse() {
		const onTransitionEnd = ((event) => {
			if (event.target !== this.contentEl || event.propertyName !== 'height') return

			this.contentEl.removeEventListener(this.transitionendEvent, onTransitionEnd)

			if (!this.isOpen) {
				this.classList.add(this.collapsedClass)
				this.classList.remove(this.closingClass)

				this.contentEl.setAttribute('hidden', 'hidden')
				this.contentEl.classList.add('l-hidden')
			}
		}).bind(this)

		this.contentEl.addEventListener(this.transitionendEvent, onTransitionEnd)
		this.isOpen = false
		this.classList.remove(this.expandedClass, this.openingClass)
		this.classList.add(this.closingClass)

		requestAnimationFrame(() => {
			this.contentEl.style.transition = '0'
			this.contentEl.style.height = this.contentEl.scrollHeight + 'px'

			requestAnimationFrame(() => {
				this.contentEl.style.transition = null
				this.contentEl.style.height = this.collapsedHeight
			})
		})

		if (this.isScrollIntoView) {
			l_debounce(() => {
				this.scrollIntoView({ behavior: 'smooth', block: 'center' })
			}, 400)()
		}
	}

	destroy() {
		this.triggerEl && this.triggerEl.removeEventListener('click', this._onTriggerClick)
		this.contentEl && this.contentEl.removeAttribute('aria-hidden')
		this.contentEl && (this.contentEl.style.height = 'auto')

		this.classList.remove(this.expandedClass, this.collapsedClass, this.openingClass, this.closingClass)
		this.removeAttribute('open')
	}

	updateNestedCarousels() {
		const carouselEls = this.contentEl?.querySelectorAll('l-swiper-carousel')
		if (!carouselEls?.length) return

		requestAnimationFrame(() => {
			carouselEls.forEach((carouselEl) => {
				carouselEl.swiperCarousel?.update?.()
			})
		})
	}

	transitionendEventName() {
		let eventName,
			testElement = document.createElement('div'),
			eventNames = {
				transition: 'transitionend',
				OTransition: 'otransitionend',
				MozTransition: 'transitionend',
				WebkitTransition: 'webkitTransitionEnd',
			}

		for (eventName in eventNames) {
			if (eventNames.hasOwnProperty(eventName) && testElement.style[eventName] !== false) {
				return eventNames[eventName]
			}
		}
	}

	setExpandedAria(autoFocus = true) {
		this.setAttribute('open', true)

		this.triggerEl.setAttribute('aria-expanded', 'true')
		this.contentEl.removeAttribute('aria-hidden')
		this.contentEl.removeAttribute('tabindex')

		if (autoFocus) {
			l_enableFocusableElements(this.contentEl)
			if (this.trapFocus) l_trapFocus(this)
		}
	}

	setCollapsedAria(elementToFocus = this.triggerEl, enableTrapFocus = true) {
		this.removeAttribute('open')

		this.triggerEl.setAttribute('aria-expanded', 'false')
		this.contentEl.setAttribute('aria-hidden', 'true')
		this.contentEl.setAttribute('tabindex', '-1')

		l_disableFocusableElements(this.contentEl)
		enableTrapFocus && this.trapFocus && l_removeTrapFocus(elementToFocus)
	}
}

customElements.define('l-collapsible-tab', LTACollapsibleTab)

class LTARichtextMoreLess extends LTACollapsibleTab {
	connectedCallback() {
		this.triggerEl = this.querySelector('[data-trigger]')
		this.contentEl = this.querySelector('[data-content]')
		this.bodyEl = this.querySelector('[data-rte-body]') || this.contentEl

		if (!this.triggerEl || !this.contentEl) return

		this.expandedClass = 'is-expanded'
		this.collapsedClass = 'is-collapsed'
		this.collapsedHeight = 'auto'
		this.oneAtATime = false
		this.isScrollIntoView = false
		this._contentFits = false

		this.transitionendEvent = this.transitionendEventName()
		this.moreLabel = this.triggerEl.dataset.labelMore
		this.lessLabel = this.triggerEl.dataset.labelLess

		this._onTriggerClick ??= (e) => this.toggle(e)
		this._onResize = l_debounce(() => this.measure(), 150)
		this._cleanups = []

		this.triggerEl.addEventListener('click', this._onTriggerClick)
		window.addEventListener('resize', this._onResize)

		this._resizeObserver = new ResizeObserver(this._onResize)
		this._resizeObserver.observe(this.contentEl)

		this._cleanups.push(
			() => this.triggerEl.removeEventListener('click', this._onTriggerClick),
			() => window.removeEventListener('resize', this._onResize),
			() => this._resizeObserver.disconnect()
		)

		if (document.fonts?.ready) {
			document.fonts.ready.then(() => this.measure())
		} else {
			requestAnimationFrame(() => this.measure())
		}
	}

	disconnectedCallback() {
		this._cleanups?.forEach((fn) => fn())
		this._cleanups = []
	}

	_getClampLines() {
		const raw = getComputedStyle(this).getPropertyValue('--l-rte-clamp-lines').trim()
		const lines = parseInt(raw, 10)
		return Number.isFinite(lines) && lines > 0 ? lines : 4
	}

	_styleMeasureClone(clone, width, { clamp = false, lines = 4 } = {}) {
		clone.removeAttribute('data-rte-body')
		clone.style.cssText = [
			'position:absolute',
			'visibility:hidden',
			'pointer-events:none',
			'inset-inline-start:-99999px',
			'top:0',
			`width:${width}px`,
			'height:auto',
			'max-height:none',
			'margin:0',
		].join(';')

		if (clamp) {
			clone.style.setProperty('display', '-webkit-box', 'important')
			clone.style.setProperty('-webkit-box-orient', 'vertical', 'important')
			clone.style.setProperty('overflow', 'hidden', 'important')
			clone.style.setProperty('-webkit-line-clamp', String(lines), 'important')
			clone.style.setProperty('line-clamp', String(lines), 'important')
			return
		}

		clone.style.setProperty('display', 'block', 'important')
		clone.style.setProperty('overflow', 'visible', 'important')
		clone.style.setProperty('-webkit-line-clamp', 'unset', 'important')
		clone.style.setProperty('line-clamp', 'unset', 'important')
	}

	_measureHeights() {
		const width = this.bodyEl.getBoundingClientRect().width
		if (width <= 0) return { fullHeight: 0, collapsedHeight: 0 }

		const lines = this._getClampLines()

		const fullClone = this.bodyEl.cloneNode(true)
		this._styleMeasureClone(fullClone, width, { clamp: false })
		this.appendChild(fullClone)
		const fullHeight = fullClone.getBoundingClientRect().height
		fullClone.remove()

		/* Measure the real line-clamp: headings are taller than N × body line-height. */
		const clampClone = this.bodyEl.cloneNode(true)
		this._styleMeasureClone(clampClone, width, { clamp: true, lines })
		this.appendChild(clampClone)
		const collapsedHeight = clampClone.getBoundingClientRect().height
		clampClone.remove()

		return { fullHeight, collapsedHeight }
	}

	measure() {
		if (!this.contentEl || !this.triggerEl || this._isAnimating || this._isMeasuring) return

		this._isMeasuring = true

		try {
			const { fullHeight, collapsedHeight } = this._measureHeights()
			const truncateNeeded = fullHeight > collapsedHeight + 1

			this._collapsedHeight = collapsedHeight
			this.collapsedHeight = `${collapsedHeight}px`

			if (!truncateNeeded) {
				this._contentFits = true
				this.selected = false
				this.isOpen = false
				this.triggerEl.hidden = true
				this.contentEl.style.height = 'auto'
				this.classList.add(this.expandedClass)
				this.classList.remove(this.collapsedClass)
				this.removeAttribute('open')
				this.triggerEl.setAttribute('aria-expanded', 'false')
				this.triggerEl.textContent = this.moreLabel
				return
			}

			this._contentFits = false
			this.triggerEl.hidden = false

			if (this.selected) {
				this.contentEl.style.height = 'auto'
				this.classList.add(this.expandedClass)
				this.classList.remove(this.collapsedClass)
				this.triggerEl.textContent = this.lessLabel
				return
			}

			this.selected = false
			this.isOpen = false
			this.contentEl.style.height = this.collapsedHeight
			this.classList.remove(this.expandedClass)
			this.classList.add(this.collapsedClass)
			this.setCollapsedAria()
			this.triggerEl.textContent = this.moreLabel
		} finally {
			this._isMeasuring = false
		}
	}

	toggle(e) {
		e.preventDefault()
		if (this._contentFits) return

		if (this.selected) {
			this.close()
			this.triggerEl.textContent = this.moreLabel
			return
		}

		this.open()
		this.triggerEl.textContent = this.lessLabel
		this.triggerEl.hidden = false
	}

	open() {
		this._isAnimating = true
		this.selected = true
		this._contentFits = false
		this.expand()
		this.setExpandedAria()
	}

	close() {
		this.selected = false
		this.collapsedHeight = `${this._collapsedHeight}px`
		this._isAnimating = true
		this.collapse()
		this.setCollapsedAria()
	}

	expand() {
		const onTransitionEnd = ((event) => {
			if (event.target !== this.contentEl || event.propertyName !== 'height') return

			this.contentEl.removeEventListener(this.transitionendEvent, onTransitionEnd)
			this._isAnimating = false

			if (!this.isOpen) return

			requestAnimationFrame(() => {
				this.contentEl.style.transition = '0'
				this.contentEl.style.height = 'auto'

				requestAnimationFrame(() => {
					this.contentEl.style.height = null
					this.contentEl.style.transition = null
				})
			})
		}).bind(this)

		this.contentEl.addEventListener(this.transitionendEvent, onTransitionEnd)
		this.isOpen = true
		this.classList.add(this.expandedClass)
		this.classList.remove(this.collapsedClass)
		this.contentEl.style.height = this.contentEl.scrollHeight + 'px'
	}

	collapse() {
		const onTransitionEnd = ((event) => {
			if (event.target !== this.contentEl || event.propertyName !== 'height') return

			this.contentEl.removeEventListener(this.transitionendEvent, onTransitionEnd)

			if (!this.isOpen) {
				this.classList.add(this.collapsedClass)
				this.classList.remove(this.expandedClass)
				this.contentEl.style.height = this.collapsedHeight
			}

			this._isAnimating = false
			this.measure()
		}).bind(this)

		this.contentEl.addEventListener(this.transitionendEvent, onTransitionEnd)
		this.isOpen = false

		requestAnimationFrame(() => {
			this.contentEl.style.transition = '0'
			this.contentEl.style.height = this.contentEl.scrollHeight + 'px'

			requestAnimationFrame(() => {
				this.contentEl.style.transition = null
				this.contentEl.style.height = this.collapsedHeight
			})
		})
	}

	/* Clamped text stays readable/focusable: no aria-hidden or tabindex on content. */
	setExpandedAria() {
		this.setAttribute('open', true)
		this.triggerEl.setAttribute('aria-expanded', 'true')
	}

	setCollapsedAria() {
		this.removeAttribute('open')
		this.triggerEl.setAttribute('aria-expanded', 'false')
	}
}

customElements.define('l-richtext-more-less', LTARichtextMoreLess)

class LTATabs extends HTMLElement {
	constructor() {
		super()
		this._boundClicks = []
	}

	connectedCallback() {
		this._cacheElements()
		this._delegateEvents()
	}

	disconnectedCallback() {
		this._removeEvents()
	}

	_cacheElements() {
		this.triggerEls = [...this.querySelectorAll('[data-trigger]')]
		this.contentEls = [...this.querySelectorAll('[data-content]')]
	}

	_delegateEvents() {
		this._removeEvents()
		this._boundClicks = this.triggerEls.map((triggerEl) => {
			const handler = (e) => this._onTriggerClick(e, triggerEl)
			triggerEl.addEventListener('click', handler)
			return { triggerEl, handler }
		})
	}

	_removeEvents() {
		if (this._boundClicks.length) {
			this._boundClicks.forEach(({ triggerEl, handler }) => {
				triggerEl.removeEventListener('click', handler)
			})
			this._boundClicks = []
		}
	}

	_onTriggerClick(e, clickedTrigger) {
		e.preventDefault()

		const id = clickedTrigger.dataset.trigger

		this.triggerEls.forEach((triggerEl) => triggerEl.classList.toggle('is-active', triggerEl === clickedTrigger))

		this.contentEls.forEach((contentEl) => {
			const isActive = contentEl.dataset.content === id
			contentEl.classList.toggle('l-hidden', !isActive)

			isActive ? l_trapFocus(this) : l_removeTrapFocus(clickedTrigger)
		})
	}
}

customElements.define('l-tabs', LTATabs)

class LTASwiperCarousel extends HTMLElement {
	constructor() {
		super()
		this._onResize = this._onResize.bind(this)
		this._swiperInitialized = false
	}

	connectedCallback() {
		if (window?.Swiper) {
			this.setupCarousel()
			return
		}

		document.addEventListener('l:vendor:loaded', () => {
			this.setupCarousel()
		})
	}

	disconnectedCallback() {
		window.removeEventListener('resize', this._onResize)
	}

	setupCarousel() {
		const configNode = this.querySelector('[data-carousel-config]')
		if (!configNode) return

		this.carouselConfig = JSON.parse(configNode.textContent)
		if (!this.carouselConfig) return

		this.swiperSlideEls = this.querySelectorAll('.swiper-slide')

		this.classList.remove('is-placeholder')
		this.swiperSlideEls.forEach((swiperSlide) => swiperSlide.classList.remove('l-hidden'))

		this.swiperCarousel = new window.Swiper(this, this.carouselConfig)
		this._swiperInitialized = true

		if (window.Shopify?.designMode) {
			this.designModeScroll()
		}

		const hasNavigationTarget = this.carouselConfig?.navigation && this.carouselConfig.navigation.navigationHeightTarget
		if (hasNavigationTarget) {
			this.setupNavigation()
			window.addEventListener('resize', this._onResize)
		}

		if (this.dataset.dispatchEvent === 'true') {
			this.dispatchEvent(
				new CustomEvent('l:swiper:carousel:loaded', {
					bubbles: true,
					detail: {
						id: this.id || this.dataset.id || 'default',
					},
				})
			)
		}
	}

	_onResize() {
		if (this._swiperInitialized && this.carouselConfig?.navigation?.navigationHeightTarget) {
			this.setupNavigation()
		}
	}

	setupNavigation() {
		const navigation = this.carouselConfig?.navigation
		if (!navigation || !navigation.navigationHeightTarget) return

		const targetEl = this.querySelector(navigation.navigationHeightTarget)
		if (!targetEl) return

		const navTop = `${targetEl.offsetHeight / 2}px`

		const nextNavEls = document.querySelectorAll(navigation.nextEl)
		const prevNavEls = document.querySelectorAll(navigation.prevEl)

		nextNavEls.forEach((el) => el.style.setProperty('--l-swiper-top', navTop))
		prevNavEls.forEach((el) => el.style.setProperty('--l-swiper-top', navTop))
	}

	designModeScroll() {
		document.addEventListener('shopify:block:select', (event) => {
			const targetEl = event.target

			this.swiperSlideEls.forEach((swiperSlide, index0) => {
				if (targetEl === swiperSlide) this.slideTo(index0)
			})
		})
	}

	slideTo(index = 0) {
		if (this.swiperCarousel && typeof this.swiperCarousel.slideTo === 'function') {
			this.swiperCarousel.slideTo(index)
		}
	}
}

customElements.define('l-swiper-carousel', LTASwiperCarousel)

class LTAMediaVideo extends HTMLElement {
	constructor() {
		super()
	}

	connectedCallback() {
		this.videoContainerEl = this.querySelector('[data-video-container]') || this

		this.addEventListener('click', (event) => {
			const hasLoaded = this.classList.contains('is-loaded')
			const isPlaying = this.classList.contains('is-playing')

			hasLoaded ? (isPlaying ? this.pauseVideo() : this.playVideo()) : this.initPlayer(event)
		})
	}

	initPlayer(event) {
		event.preventDefault()

		const templateEl = this.querySelector('template')

		if (!templateEl) return

		this.pauseOtherVideos()

		const templateContentEl = templateEl.content.cloneNode(true)

		this.videoContainerEl.appendChild(templateContentEl)
		this.classList.add('is-loaded', 'is-playing')
		this.toggleAttribute('data-loaded', true)
		this.toggleAttribute('data-playing', true)
	}

	playVideo() {
		this.pauseOtherVideos()
		l_playMedia(this)

		this.classList.add('is-playing')
		this.classList.remove('is-paused')
		this.toggleAttribute('data-playing', true)
	}

	pauseVideo() {
		l_pauseAllMedia(this)

		this.classList.remove('is-playing')
		this.classList.add('is-paused')
		this.removeAttribute('data-playing')
	}

	pauseOtherVideos() {
		l_pauseAllMedia(this.parentElement)

		this.parentElement.querySelectorAll('l-media-video').forEach((videoEl) => {
			const isLoaded = videoEl.classList.contains('is-loaded')

			if (isLoaded) {
				videoEl.classList.remove('is-playing')
				videoEl.classList.add('is-paused')
				videoEl.removeAttribute('data-playing')
			}
		})
	}
}

customElements.define('l-media-video', LTAMediaVideo)

class LTADrawer extends HTMLElement {
	constructor() {
		super()
	}

	connectedCallback() {
		this.setupDrawer()
	}

	setupDrawer() {
		const showInBody = this.dataset.showInBody === 'true'

		if (showInBody) {
			const mainContentEl = document.getElementById('main-content')
			const isInContainer = mainContentEl.contains(this)

			if (isInContainer) {
				document.body.appendChild(this)

				return
			}
		}

		const templateEl = this.querySelector('template')
		if (templateEl) {
			const templateContentEl = templateEl.content.cloneNode(true)
			this.appendChild(templateContentEl)
		}

		this.drawer_init()
	}

	drawer_init() {
		this.triggerEls = document.querySelectorAll(this.dataset.triggerSelector)
		this.closeBtnEls = this.querySelectorAll('[data-close]')
		this.drawerInnerEl = this.querySelector('[data-drawer-inner]')
		this.triggerEl = null
		this._onOutsideClick = this.drawer_closeOutsideOnClick.bind(this)
		this._onEscape = this.drawer_closeOutsideOnEscape.bind(this)

		if (this.dataset.closeSelector) {
			const externalCloseBtnEls = document.querySelectorAll(this.dataset.closeSelector)
			this.closeBtnEls = Array.from(this.closeBtnEls).concat(Array.from(externalCloseBtnEls))
		}

		this.onlyOneDrawerOpen = this.dataset.onlyOneDrawerOpen === 'true'
		this.drawerName = this.dataset.drawerName || 'drawer'

		if (this.onlyOneDrawerOpen) {
			document.addEventListener('l:drawer:open', (event) => {
				if (event.detail.drawerName !== this.drawerName) {
					this.drawer_close()
				}
			})
		}

		this.triggerEls.forEach((triggerEl) => {
			triggerEl.addEventListener('click', (event) => {
				event.preventDefault()

				this.drawer_open(triggerEl)
			})
		})

		this.setupCloseEvent()

		if (window.Shopify?.designMode && this.dataset.sectionId) {
			this.drawer_editorMode()
		}
	}

	setupCloseEvent() {
		this.closeBtnEls.forEach((closeBtnEl) => {
			closeBtnEl.addEventListener('click', () => {
				this.drawer_close()
			})
		})
	}

	get _isInstantTransition() {
		return this.dataset.instantTransitions === 'true' || this.classList.contains('l-hMDrawer--sub')
	}

	drawer_open(triggerEl) {
		l_setupVariablesBeforeOpenModal()
		l_lockBodyScroll(this.drawerName)

		this.classList.add('is-expanding')
		this.classList.remove('l-hidden')
		this.classList.toggle('is-instant', this._isInstantTransition)
		if (this._isInstantTransition) {
			this.classList.add('is-active')
		} else {
			requestAnimationFrame(() => {
				this.classList.add('is-active')
			})
		}

		if (triggerEl) {
			this.triggerEl = triggerEl
			l_trapFocus(this.drawerInnerEl, this.defaultElementToFocus)
		}

		this.setAttribute('aria-expanded', 'true')
		this.removeAttribute('tabindex')
		this.hasAttribute('aria-hidden') && this.setAttribute('aria-hidden', 'false')
		this.drawer_syncTriggerAria(true)

		window.addEventListener('click', this._onOutsideClick)
		window.addEventListener('keyup', this._onEscape)

		document.dispatchEvent(
			new CustomEvent('l:drawer:open', {
				detail: { drawerName: this.drawerName },
			})
		)
	}

	drawer_close() {
		l_unLockBodyScroll(this.drawerName)

		this.classList.remove('is-active')

		const finishClose = () => {
			this.classList.remove('is-expanding')
			this.classList.add('l-hidden')
		}

		if (this._isInstantTransition) {
			finishClose()
		} else {
			window.l_debounce(finishClose, 400)()
		}

		if (this.triggerEl) {
			l_removeTrapFocus(this.triggerEl)
			this.triggerEl = null
		}

		this.setAttribute('aria-expanded', 'false')
		this.setAttribute('tabindex', '-1')
		this.hasAttribute('aria-hidden') && this.setAttribute('aria-hidden', 'true')
		this.drawer_syncTriggerAria(false)

		window.removeEventListener('click', this._onOutsideClick)
		window.removeEventListener('keyup', this._onEscape)
	}

	drawer_syncTriggerAria(isOpen) {
		if (!this.id) return

		document.querySelectorAll(`[aria-controls="${CSS.escape(this.id)}"]`).forEach((el) => {
			el.setAttribute('aria-expanded', isOpen ? 'true' : 'false')
		})
	}

	drawer_editorMode() {
		document.addEventListener('shopify:section:select', (event) => {
			const selectedSectionId = event.detail.sectionId
			const sectionId = this.dataset.sectionId

			if (sectionId === selectedSectionId) {
				this.drawer_open()
			}
		})
	}

	drawer_closeOutsideOnClick(event) {
		if (!this.classList.contains('is-active')) return

		const target = event.target
		const triggerSelector = this.dataset.drawerTriggerSelector || 'l-drawer-trigger'
		const isDrawerTrigger = event.target.closest(triggerSelector) || event.target.tagName == triggerSelector

		const isOutsideClick =
			!this.drawerInnerEl.contains(target) &&
			!Array.from(this.triggerEls).some((el) => el.contains(target)) &&
			!isDrawerTrigger

		if (isOutsideClick) this.drawer_close()
	}

	drawer_closeOutsideOnEscape(event) {
		if (!this.classList.contains('is-active')) return

		if (event.code?.toUpperCase() === 'ESCAPE') {
			this.drawer_close()
		}
	}
}

customElements.define('l-drawer', LTADrawer)

class LTADrawerTrigger extends HTMLElement {
	constructor() {
		super()
	}

	connectedCallback() {
		this.drawerEl = document.querySelector(this.dataset.selector)

		if (this.drawerEl) {
			this.addEventListener('click', () => {
				this.drawerEl?.drawer_open?.(this)
			})
		}
	}
}

customElements.define('l-drawer-trigger', LTADrawerTrigger)

class LTAQtyInput extends HTMLElement {
	constructor() {
		super()

		this.onButtonClick = this.onButtonClick.bind(this)
		this.onInputChange = this.onInputChange.bind(this)
		this.onInputBeforeChange = this.onInputBeforeChange.bind(this)
	}

	connectedCallback() {
		this.input = this.querySelector('input')
		this.buttonMinus = this.querySelector("button[name='minus']")
		this.buttonPlus = this.querySelector("button[name='plus']")

		if (!this.input) return

		this.changeEvent = new Event('change', { bubbles: true })

		this.validateQtyRules()
		this.setupEventListeners()
	}

	setupEventListeners() {
		this.input.addEventListener('input', this.onInputBeforeChange)
		this.input.addEventListener('change', this.onInputChange)
		this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.onButtonClick))
	}

	onInputBeforeChange() {
		const value = parseInt(this.input.value)

		if (isNaN(value)) return

		const min = parseInt(this.input.min)
		const max = parseInt(this.input.max)
		let newValue = value

		if (!isNaN(min) && value < min) {
			newValue = min
		}

		if (!isNaN(max) && value > max) {
			newValue = max
		}

		if (newValue !== value) {
			this.input.value = newValue
		}
	}

	onInputChange() {
		this.validateQtyRules()
	}

	onButtonClick(event) {
		event.preventDefault()

		const previousValue = this.input.value
		const buttonName = event.target.name

		if (buttonName === 'plus') {
			this.incrementQuantity()
		} else if (buttonName === 'minus') {
			this.decrementQuantity()
		}

		if (previousValue !== this.input.value) {
			this.input.dispatchEvent(this.changeEvent)
			this.onQuantityChanged(previousValue, parseInt(this.input.value))
		}
	}

	onQuantityChanged(oldValue, newValue) {}

	incrementQuantity() {
		const min = parseInt(this.input.dataset.min)
		const step = parseInt(this.input.step)
		const value = parseInt(this.input.value)

		if (min > step && value === 0) {
			this.input.value = min
		} else {
			this.input.stepUp()
		}
	}

	decrementQuantity() {
		const min = this.input.dataset.min
		if (min && min === this.input.value) {
			this.input.value = parseInt(this.input.min)

			return
		}

		this.input.stepDown()
	}

	validateQtyRules() {
		const value = parseInt(this.input.value)

		if (this.input.min && this.buttonMinus) {
			this.buttonMinus.toggleAttribute('disabled', value <= parseInt(this.input.min))
		}

		if (this.input.max && this.buttonPlus) {
			this.buttonPlus.toggleAttribute('disabled', value >= parseInt(this.input.max))
		}
	}

	disconnectedCallback() {
		if (this.input) {
			this.input.removeEventListener('input', this.onInputBeforeChange)
			this.input.removeEventListener('change', this.onInputChange)
		}

		this.querySelectorAll('button').forEach((button) => button.removeEventListener('click', this.onButtonClick))
	}
}

if (!customElements.get('l-qty-input')) customElements.define('l-qty-input', LTAQtyInput)

/*****************************************
 * [COMPONENT]: CUSTOM SELECT
 * Combobox/listbox over a native <select>.
 * Mobile = bottom sheet; desktop = dropdown under trigger.
 * Focus stays on the trigger (aria-activedescendant), so the global
 * l_trapFocus is not used — it is single-layer and would drop the trap
 * of a parent drawer/modal hosting this select.
 *****************************************/

class LTACustomSelect extends HTMLElement {
	static MOBILE_MQ = '(max-width: 767px)'
	static SECTION_OPEN_CLASS = 'is-cCSelect-open'
	static HIDE_DELAY_MS = 400

	constructor() {
		super()
		this._onTriggerClick = this._onTriggerClick.bind(this)
		this._onTriggerKeydown = this._onTriggerKeydown.bind(this)
		this._onCloseClick = this.close.bind(this)
		this._onNativeChange = this._syncFromNative.bind(this)
		this._onOptionClick = this._onOptionClick.bind(this)
		this._onOutsideClick = this._onOutsideClick.bind(this)
		this._onDocumentKeydown = this._onDocumentKeydown.bind(this)
		this._onWindowResize = this._onWindowResize.bind(this)

		this._cleanups = []
		this._isOpen = false
		this._sectionEl = null
		this._hideModalTimer = null
		this._scrollLocked = false
	}

	/* ---------------------------------
	 * Lifecycle
	 * --------------------------------- */

	connectedCallback() {
		this._cacheElements()
		if (!this._isReady()) return

		this.changeEvent = new Event('change', { bubbles: true })
		this._bindEvents()
		this._syncFromNative()
	}

	disconnectedCallback() {
		if (this._isOpen) this.close()
		this._clearHideModalTimer()
		this._releaseSection()
		this._unbindWindowListeners()
		this._runCleanups()
	}

	/* ---------------------------------
	 * Setup
	 * --------------------------------- */

	_cacheElements() {
		this.triggerEl = this.querySelector('[data-trigger]')
		this.triggerContentEl = this.querySelector('[data-trigger-content]') || this.triggerEl
		this.modalEl = this.querySelector('[data-modal]')
		this.modalContainerEl = this.querySelector('[data-modal-container]')
		this.listboxEl = this.querySelector('[role="listbox"]')
		this.nativeSelectEl = this.querySelector('select')
		this.optionEls = Array.from(this.querySelectorAll('[data-option-value][role="option"]'))
		this.closeEls = this.querySelectorAll('[data-close]')
		this._sectionEl = this.closest('.shopify-section')
	}

	_isReady() {
		return Boolean(this.triggerEl && this.modalEl && this.nativeSelectEl && this.listboxEl && this.optionEls.length)
	}

	_bindEvents() {
		this.triggerEl.addEventListener('click', this._onTriggerClick)
		this.triggerEl.addEventListener('keydown', this._onTriggerKeydown)
		this._cleanups.push(() => {
			this.triggerEl.removeEventListener('click', this._onTriggerClick)
			this.triggerEl.removeEventListener('keydown', this._onTriggerKeydown)
		})

		this.closeEls.forEach((el) => {
			el.addEventListener('click', this._onCloseClick)
			this._cleanups.push(() => el.removeEventListener('click', this._onCloseClick))
		})

		this.nativeSelectEl.addEventListener('change', this._onNativeChange)
		this._cleanups.push(() => this.nativeSelectEl.removeEventListener('change', this._onNativeChange))

		this.optionEls.forEach((optionEl) => {
			optionEl.addEventListener('click', this._onOptionClick)
			this._cleanups.push(() => optionEl.removeEventListener('click', this._onOptionClick))
		})
	}

	_runCleanups() {
		this._cleanups.forEach((fn) => {
			try {
				fn()
			} catch {}
		})
		this._cleanups = []
	}

	/* ---------------------------------
	 * Helpers
	 * --------------------------------- */

	_isMobile() {
		return window.matchMedia(LTACustomSelect.MOBILE_MQ).matches
	}

	_isRtl() {
		return getComputedStyle(this).direction === 'rtl'
	}

	/* Desktop dropdown: flip inline alignment so it stays in the viewport */
	_positionDropdown() {
		if (this._isMobile() || !this.modalContainerEl || !this.triggerEl) return

		const container = this.modalContainerEl
		const margin = 16
		const vw = window.innerWidth
		const triggerRect = this.triggerEl.getBoundingClientRect()
		const rtl = this._isRtl()

		container.classList.remove('is-align-end')
		container.style.removeProperty('max-width')

		const dropdownWidth = container.offsetWidth
		/* Aligned to inline-start → grows toward inline-end */
		const spaceIfStart = rtl ? triggerRect.right - margin : vw - triggerRect.left - margin
		/* Aligned to inline-end → grows toward inline-start */
		const spaceIfEnd = rtl ? vw - triggerRect.left - margin : triggerRect.right - margin

		const alignEnd = dropdownWidth > spaceIfStart && spaceIfEnd >= spaceIfStart
		if (alignEnd) container.classList.add('is-align-end')

		const available = Math.max(0, alignEnd ? spaceIfEnd : spaceIfStart)
		if (dropdownWidth > available) {
			container.style.maxWidth = `${available}px`
		}
	}

	_resetDropdownPosition() {
		if (!this.modalContainerEl) return
		this.modalContainerEl.classList.remove('is-align-end')
		this.modalContainerEl.style.removeProperty('max-width')
	}

	/* Skips only aria-disabled (true non-operable). Sold-out stays selectable. */
	_enabledOptions() {
		return this.optionEls.filter((el) => el.getAttribute('aria-disabled') !== 'true')
	}

	/* Close peer dropdowns in the same section */
	_closeSiblingDropdowns() {
		const scope = this._sectionEl
		if (!scope) return

		scope.querySelectorAll('l-custom-select').forEach((el) => {
			if (el !== this && typeof el.close === 'function' && el._isOpen) el.close()
		})
	}

	_elevateSection() {
		this._sectionEl?.classList.add(LTACustomSelect.SECTION_OPEN_CLASS)
	}

	_releaseSection() {
		this._sectionEl?.classList.remove(LTACustomSelect.SECTION_OPEN_CLASS)
	}

	_clearHideModalTimer() {
		if (this._hideModalTimer == null) return
		clearTimeout(this._hideModalTimer)
		this._hideModalTimer = null
	}

	_bindWindowListeners() {
		window.addEventListener('click', this._onOutsideClick)
		window.addEventListener('keydown', this._onDocumentKeydown)
		window.addEventListener('resize', this._onWindowResize)
	}

	_unbindWindowListeners() {
		window.removeEventListener('click', this._onOutsideClick)
		window.removeEventListener('keydown', this._onDocumentKeydown)
		window.removeEventListener('resize', this._onWindowResize)
	}

	/* ---------------------------------
	 * Open / close
	 * --------------------------------- */

	_onTriggerClick(event) {
		event.preventDefault()
		if (this.triggerEl.disabled) return
		this._isOpen ? this.close() : this.open()
	}

	_onTriggerKeydown(event) {
		const key = event.key
		if (
			key !== 'ArrowDown' &&
			key !== 'ArrowUp' &&
			key !== 'ArrowLeft' &&
			key !== 'ArrowRight' &&
			key !== 'Enter' &&
			key !== ' ' &&
			key !== 'Home' &&
			key !== 'End' &&
			key !== 'Escape'
		) {
			return
		}

		/* Combobox pattern: focus stays on the trigger — handle open-state nav here */
		if (this._isOpen) {
			if (key === 'Escape') {
				event.preventDefault()
				this.close()
				return
			}

			const options = this._enabledOptions()
			if (!options.length) return

			if (key === 'Enter' || key === ' ') {
				event.preventDefault()
				const active = options.find((el) => el.getAttribute('data-active') === 'true')
				if (active) this._selectOption(active)
				return
			}

			event.preventDefault()
			this._moveActiveOption(key, options)
			return
		}

		if (key === 'Escape') return

		if (key === 'Home' || key === 'End') return

		event.preventDefault()
		const rtl = this._isRtl()
		const openLast = key === 'ArrowUp' || key === (rtl ? 'ArrowRight' : 'ArrowLeft')
		this.open(openLast ? 'last' : 'selected')
	}

	open(focusTarget = 'selected') {
		if (this._isOpen || this.triggerEl.disabled) return
		if (this.modalEl.classList.contains('is-hidden')) return

		this._closeSiblingDropdowns()
		this._clearHideModalTimer()
		this._isOpen = true
		this.triggerEl.classList.add('is-active')
		this.triggerEl.setAttribute('aria-expanded', 'true')

		const isMobile = this._isMobile()
		if (isMobile) this._elevateSection()

		this.modalEl.hidden = false
		this.modalEl.classList.remove('l-hidden')
		this._positionDropdown()
		requestAnimationFrame(() => {
			if (!this._isOpen) return
			this.modalEl.classList.add('is-active')
			this._positionDropdown()
		})

		if (isMobile) {
			l_lockBodyScroll('custom-select')
			this._scrollLocked = true
		}

		this._focusInitialOption(focusTarget)
		this.triggerEl.focus({ preventScroll: true })

		// Defer: opening click must not count as an outside click
		requestAnimationFrame(() => {
			if (!this._isOpen) return
			this._bindWindowListeners()
		})
	}

	close() {
		if (!this._isOpen) return

		this._isOpen = false
		this.triggerEl.classList.remove('is-active')
		this.triggerEl.setAttribute('aria-expanded', 'false')
		this.modalEl.classList.remove('is-active')
		this._clearActiveOption()

		if (this._scrollLocked) {
			l_unLockBodyScroll('custom-select')
			this._scrollLocked = false
		}

		this._scheduleHideModal()
		this._returnFocusToTrigger()
		this._unbindWindowListeners()
	}

	_scheduleHideModal() {
		this._clearHideModalTimer()
		this._hideModalTimer = setTimeout(() => {
			this._hideModalTimer = null
			if (this._isOpen) return
			this.modalEl.classList.add('l-hidden')
			this.modalEl.hidden = true
			this._resetDropdownPosition()
			this._releaseSection()
		}, LTACustomSelect.HIDE_DELAY_MS)
	}

	_returnFocusToTrigger() {
		if (this.isConnected) this.triggerEl.focus({ preventScroll: true })
	}

	_onOutsideClick(event) {
		const target = event.target
		if (this.triggerEl.contains(target) || this.modalEl.contains(target)) return
		this.close()
	}

	_onWindowResize() {
		if (!this._isOpen) return
		this._positionDropdown()
	}

	/* ---------------------------------
	 * Keyboard (listbox: arrows, not Tab)
	 * --------------------------------- */

	_onDocumentKeydown(event) {
		if (!this._isOpen) return

		const key = event.key

		/* Tab leaves the combobox — close without blocking natural focus move */
		if (key === 'Tab') {
			this.close()
			return
		}

		/* Trigger already handles arrows/Enter while focused; this covers focus inside the sheet */
		if (this.triggerEl.contains(event.target) || event.target === this.triggerEl) return

		const options = this._enabledOptions()
		if (!options.length) return

		if (key === 'Escape') {
			event.preventDefault()
			this.close()
			return
		}

		if (
			key === 'ArrowDown' ||
			key === 'ArrowUp' ||
			key === 'ArrowLeft' ||
			key === 'ArrowRight' ||
			key === 'Home' ||
			key === 'End'
		) {
			event.preventDefault()
			this._moveActiveOption(key, options)
			return
		}

		if (key === 'Enter' || key === ' ') {
			event.preventDefault()
			const active = options.find((el) => el.getAttribute('data-active') === 'true')
			if (active) this._selectOption(active)
		}
	}

	_moveActiveOption(key, options) {
		let index = options.findIndex((el) => el.getAttribute('data-active') === 'true')
		if (index < 0) index = 0

		/* Horizontal arrows follow reading direction (RTL flips Left/Right) */
		const rtl = this._isRtl()
		const isNext = key === 'ArrowDown' || key === (rtl ? 'ArrowLeft' : 'ArrowRight')
		const isPrev = key === 'ArrowUp' || key === (rtl ? 'ArrowRight' : 'ArrowLeft')

		if (isNext) index = Math.min(index + 1, options.length - 1)
		if (isPrev) index = Math.max(index - 1, 0)
		if (key === 'Home') index = 0
		if (key === 'End') index = options.length - 1

		this._setActiveOption(options[index])
	}

	/* ---------------------------------
	 * Selection / sync
	 * --------------------------------- */

	_onOptionClick(event) {
		const optionEl = event.currentTarget
		if (optionEl.getAttribute('aria-disabled') === 'true') return
		this._selectOption(optionEl)
	}

	_selectOption(optionEl) {
		const value = optionEl.dataset.optionValue
		if (value == null) return

		this.nativeSelectEl.value = value
		Array.from(this.nativeSelectEl.options).forEach((opt) => {
			if (opt.value === value) opt.setAttribute('selected', 'selected')
			else opt.removeAttribute('selected')
		})

		this.nativeSelectEl.dispatchEvent(this.changeEvent)
		this._syncFromNative()
		this.close()
	}

	_focusInitialOption(focusTarget) {
		const options = this._enabledOptions()
		let index = options.findIndex((el) => el.classList.contains('is-selected'))
		if (focusTarget === 'last') index = options.length - 1
		if (index < 0) index = 0
		this._setActiveOption(options[index] || null)
	}

	_clearActiveOption() {
		this.listboxEl.removeAttribute('aria-activedescendant')
		this.triggerEl.removeAttribute('aria-activedescendant')
		this.optionEls.forEach((el) => el.removeAttribute('data-active'))
	}

	_setActiveOption(optionEl) {
		this.optionEls.forEach((el) => el.removeAttribute('data-active'))

		if (!optionEl) {
			this.listboxEl.removeAttribute('aria-activedescendant')
			this.triggerEl.removeAttribute('aria-activedescendant')
			return
		}

		optionEl.setAttribute('data-active', 'true')
		if (optionEl.id) {
			this.listboxEl.setAttribute('aria-activedescendant', optionEl.id)
			this.triggerEl.setAttribute('aria-activedescendant', optionEl.id)
		}
		optionEl.scrollIntoView({ block: 'nearest' })
	}

	_syncFromNative() {
		const selectedValue = this.nativeSelectEl.value

		this.optionEls.forEach((optionEl) => {
			const isSelected = optionEl.dataset.optionValue == selectedValue
			optionEl.classList.toggle('is-selected', isSelected)
			optionEl.setAttribute('aria-selected', isSelected ? 'true' : 'false')
			if (isSelected) this.triggerContentEl.innerHTML = optionEl.innerHTML
		})
	}
}

if (!customElements.get('l-custom-select')) customElements.define('l-custom-select', LTACustomSelect)

class LTACTAButton extends HTMLElement {
	constructor() {
		super()

		this.handleAtcBtnClick = this.handleAtcBtnClick.bind(this)
	}

	connectedCallback() {
		this.buttonEl = this.querySelector('button:not([data-qty-btn])')
		if (this.buttonEl) {
			this.buttonEl.addEventListener('click', this.handleAtcBtnClick)
		}
	}

	disconnectedCallback() {
		if (this.buttonEl) {
			this.buttonEl.removeEventListener('click', this.handleAtcBtnClick)
		}
	}

	handleAtcBtnClick() {
		if (!this.buttonEl || this.buttonEl.classList.contains('is-loading')) return

		const { variantId, quantity, sellingPlanId, properties } = this.dataset
		const qty = parseInt(quantity, 10)
		const maxQty = parseInt(this.dataset.maxQuantity, 10)
		const minQty = parseInt(this.dataset.minQuantity, 10)

		if (!Number.isFinite(qty) || qty < 1 || (Number.isFinite(minQty) && qty < minQty)) {
			this.dispatchCartError('invalid')
			return
		}

		if (Number.isFinite(maxQty) && qty > maxQty) {
			this.dispatchCartError('stock')
			return
		}

		this.buttonEl.classList.add('is-loading', 'l-button-loading')

		const config = {
			id: variantId,
			quantity: qty,
			...(sellingPlanId ? { selling_plan: sellingPlanId } : {}),
		}

		if (properties) {
			try {
				const parsed = JSON.parse(properties)
				if (parsed && typeof parsed === 'object' && Object.keys(parsed).length) {
					config.properties = parsed
				}
			} catch (error) {}
		}

		const formData = ltaCartService.createConfigFromItems([config])

		ltaCartService
			.addToCart(formData, 'l-atc-button')
			.catch(() => {
				this.dispatchCartError('network')
			})
			.finally(() => {
				this.buttonEl.classList.remove('is-loading', 'l-button-loading')
			})
	}

	dispatchCartError(status) {
		const description = status === 'stock' ? 'Not enough items available.' : 'Could not add to cart. Please try again.'

		document.dispatchEvent(
			new CustomEvent('l:cart:error', {
				detail: {
					id: 'l-atc-button',
					variantId: this.dataset.variantId || null,
					status,
					description,
				},
			})
		)
	}
}

customElements.define('l-atc-button', LTACTAButton)

class LTAProductCard extends HTMLElement {
	constructor() {
		super()
	}

	connectedCallback() {
		this.qtyInputEl = this.querySelector('l-qty-input [data-qty-input]')
		this.atcBtnEl = this.querySelector('l-atc-button')

		if (this.qtyInputEl) {
			this.qtyInputEl.addEventListener('change', this.handleQtyInputChange.bind(this))
		}
	}

	handleQtyInputChange() {
		const quantity = this.qtyInputEl.value
		this.atcBtnEl.dataset.quantity = quantity
	}
}

customElements.define('l-product-card', LTAProductCard)

if (!customElements.get('l-age-verification-popup')) {
	class LTAAgeVerificationPopup extends customElements.get('l-drawer') {
		connectedCallback() {
			this.yesButtonEl = this.querySelector('[data-age-verification-popup-yes]')
			this.cookieDurationDays = Number(this.dataset.cookieDurationDays) || 365

			super.connectedCallback()

			if (Shopify.designMode) {
				this.handleDesignMode()
			} else {
				this.togglePopup()
			}

			this.yesButtonEl?.addEventListener('click', this.handleYesButtonClick.bind(this))
		}

		handleYesButtonClick() {
			this.setAgeVerificationCookie('true')
			this.togglePopup()
		}

		togglePopup() {
			const isUserVerified = this.getAgeVerificationCookie() === 'true'

			if (isUserVerified) {
				super.drawer_close?.()
			} else {
				super.drawer_open?.(this.triggerEl)
			}
		}

		getAgeVerificationCookie() {
			const cookieName = 'age_verification='
			const cookies = document.cookie.split(';')

			for (const cookie of cookies) {
				const trimmedCookie = cookie.trim()

				if (trimmedCookie.startsWith(cookieName)) {
					return decodeURIComponent(trimmedCookie.substring(cookieName.length))
				}
			}

			return null
		}

		setAgeVerificationCookie(value) {
			const durationDays = Math.max(this.cookieDurationDays, 1)
			const maxAge = Math.round(durationDays * 24 * 60 * 60)
			const expiresAt = new Date(Date.now() + maxAge * 1000).toUTCString()
			const secureAttribute = window.location.protocol === 'https:' ? '; Secure' : ''

			document.cookie = `age_verification=${encodeURIComponent(
				value
			)}; max-age=${maxAge}; expires=${expiresAt}; path=/; SameSite=Lax${secureAttribute}`
		}

		handleDesignMode() {
			document.addEventListener('shopify:section:select', (event) => {
				const { sectionId } = event.detail

				sectionId == this.dataset.sectionId ? this.drawer_open() : this.drawer_close()
			})
		}

		drawer_close() {
			l_unLockBodyScroll(this.drawerName)

			this.classList.add('l-hidden')
			this.classList.remove('is-active')
			this.classList.remove('is-expanding')

			if (this.triggerEl) {
				l_removeTrapFocus(this.triggerEl)
				this.triggerEl = null
			}

			this.setAttribute('aria-expanded', 'false')
			this.setAttribute('tabindex', '-1')
		}

		drawer_closeOutsideOnClick(event) {}

		drawer_closeOutsideOnEscape(event) {}
	}

	customElements.define('l-age-verification-popup', LTAAgeVerificationPopup)
}

function l_initializeGlobalEventListeners() {
	l_removeMediaPlaceholderOnLoad()

	window.addEventListener('DOMContentLoaded', () => {
		l_setupGlobalVariables()
		l_detectInputType()
		l_addClassesToRteTables()
		l_setupVariablesBeforeOpenModal()
		l_setStaticHeaderGroupHeights()
		l_smoothScrollOnAnchorTags()
		l_initFakeMobileScrollbar()
		l_initHoverPrefetchLinks(document.querySelectorAll('[data-prefetch-link]'))
	})

	document.fonts?.ready.then(l_setStaticHeaderGroupHeights)

	let staticHeightsWidth = window.innerWidth
	const setStaticHeightsOnWidthChange = l_debounce(() => {
		if (window.innerWidth === staticHeightsWidth) return

		staticHeightsWidth = window.innerWidth
		l_setStaticHeaderGroupHeights()
	}, 100)

	window.addEventListener('resize', setStaticHeightsOnWidthChange)
	;['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach((eventName) => {
		document.addEventListener(eventName, () => window.requestAnimationFrame(l_setStaticHeaderGroupHeights))
	})

	const setupModalVarsDebounced = l_debounce(() => {
		l_setupVariablesBeforeOpenModal()
	}, 20)

	window.addEventListener('scroll', setupModalVarsDebounced)
	window.addEventListener('resize', setupModalVarsDebounced)
	window.addEventListener(
		'scroll',
		() => {
			l_initFakeMobileScrollbar()
		},
		{ passive: true }
	)

	if (window.visualViewport) {
		window.visualViewport.addEventListener('resize', setupModalVarsDebounced)
	}
}

l_initializeGlobalEventListeners()

function l_updateCartCount(itemCount) {
	const count = Number(itemCount) || 0

	const cartCountEls = document.querySelectorAll('[data-cart-count]')
	cartCountEls.forEach((cartCountEl) => {
		cartCountEl.textContent = count
	})

	const cartCountWraps = document.querySelectorAll('[data-cart-count-wrap]')
	cartCountWraps.forEach((cartCountWrap) => {
		cartCountWrap.hidden = count === 0
	})
}

async function l_fetchAndUpdateCartCount() {
	try {
		const res = await fetch(`${window.LTATheme.routes.cart_url}.js`)
		const cartData = await res.json()

		l_updateCartCount(cartData.item_count)
	} catch (error) {
		console.error('Error fetching cart count:', error)
	}
}

document.addEventListener('l:product:added', l_fetchAndUpdateCartCount)
document.addEventListener('l:cart:error', l_fetchAndUpdateCartCount)

document.addEventListener('l:cart:updated', (event) => {
	const cartData = event.detail.cart

	l_updateCartCount(cartData.item_count)
})

if (!customElements.get('l-read-more')) {
	class LTAReadMore extends HTMLElement {
		constructor() {
			super()
			this._onToggle = this._onToggle.bind(this)
			this._onResize = l_debounce(this._evaluate.bind(this), 200)
		}

		connectedCallback() {
			this.contentEl = this.querySelector('[data-readmore-content]')
			this.toggleEl = this.querySelector('[data-readmore-toggle]')
			this.moreEl = this.querySelector('[data-readmore-more]')
			this.lessEl = this.querySelector('[data-readmore-less]')
			if (!this.contentEl || !this.toggleEl) return

			this.toggleEl.addEventListener('click', this._onToggle)
			window.addEventListener('resize', this._onResize)

			requestAnimationFrame(() => this._evaluate())
		}

		disconnectedCallback() {
			if (this.toggleEl) this.toggleEl.removeEventListener('click', this._onToggle)
			window.removeEventListener('resize', this._onResize)
		}

		_evaluate() {
			if (this.classList.contains('is-expanded')) {
				this.toggleEl.hidden = false
				return
			}

			const overflowing = this.contentEl.scrollHeight - this.contentEl.clientHeight > 1
			this.toggleEl.hidden = !overflowing
		}

		_onToggle() {
			const expanded = this.classList.toggle('is-expanded')

			this.toggleEl.setAttribute('aria-expanded', expanded ? 'true' : 'false')
			if (this.moreEl) this.moreEl.hidden = expanded
			if (this.lessEl) this.lessEl.hidden = !expanded
		}
	}

	customElements.define('l-read-more', LTAReadMore)
}

